export default __webpack_public_path__ + "static/media/pin.2683e625.svg";